import PropTypes from 'prop-types'
import React from 'react'

import { UNIT_TYPES } from 'constants'

import styles from './UnitsList.scss'
import TableHeader from './components/TableHeader/TableHeader'
import TableBody from './components/TableBody/TableBody'

export class UnitsList extends React.Component {
    static propTypes = {
        filter: PropTypes.shape({
            levels: PropTypes.arrayOf(PropTypes.number),
            unitType: PropTypes.oneOf(Object.values(UNIT_TYPES)),
        }).isRequired,
        updateCooldown: PropTypes.bool.isRequired,

        updateListHandler: PropTypes.func.isRequired,
    }

    render() {
        return (
            <div className={styles.base}>
                <div className={styles.tableHeader}>
                    <TableHeader />
                </div>
                <div className={styles.unitsList}>
                    <TableBody
                        filter={this.props.filter}
                        updateListHandler={this.props.updateListHandler}
                        updateCooldown={this.props.updateCooldown}
                    />
                </div>
            </div>
        )
    }
}

export default UnitsList



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/UnitsList/UnitsList.jsx